import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useThemeColors } from '../../hooks/useThemeColors'

export default function AuthStatusIndicator() {
  const { loading } = useAuth()
  const colors = useThemeColors()
  const [showIndicator, setShowIndicator] = React.useState(false)

  React.useEffect(() => {
    // Only show indicator if loading takes more than 500ms
    const timer = setTimeout(() => {
      if (loading) {
        setShowIndicator(true)
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [loading])

  React.useEffect(() => {
    if (!loading) {
      // Hide indicator after a short delay
      const hideTimer = setTimeout(() => {
        setShowIndicator(false)
      }, 300)
      return () => clearTimeout(hideTimer)
    }
  }, [loading])

  if (!showIndicator) return null

  return (
    <>
      <style>
        {`
          @keyframes auth-spinner-spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div 
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: 'rgba(26, 26, 26, 0.9)',
          border: `1px solid ${colors.border}`,
          borderRadius: '8px',
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          zIndex: 9999,
          fontSize: '14px',
          color: colors.textSecondary,
          backdropFilter: 'blur(8px)',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease'
        }}
      >
        <div 
          style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            border: `2px solid ${colors.primary}`,
            borderTopColor: 'transparent',
            animation: 'auth-spinner-spin 1s linear infinite'
          }}
        />
        <span>Verifying authentication...</span>
      </div>
    </>
  )
}